var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-container"},[_c('div',{staticClass:"top-container"},[_c('img',{attrs:{"src":"/mediacryptos/info.svg","alt":""}}),_c('p',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.$t('Expired')))]),_c('p',{staticClass:"status-tips-text"},[_vm._v(_vm._s(_vm.$t('ExpiredText')))])]),_c('back')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }